/******/ (() => { // webpackBootstrap
/*!******************************!*\
  !*** ./src/js/collection.js ***!
  \******************************/
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// MG: This is a function to dynamically set the height of product images based on their width and a specified aspect ratio from theme settings, when filters are toggled, filters are open by default on a page (metafield driven boolean) or on page load.
document.addEventListener('DOMContentLoaded', function () {
  var productsOuterContainer = document.getElementById('collection-product-listing');
  var productsGrid = productsOuterContainer === null || productsOuterContainer === void 0 ? void 0 : productsOuterContainer.querySelector('.collection__products');
  var filterToggleButton = document.querySelector('button[data-filters-toggle-btn]');
  var aspectRatio = productsOuterContainer.dataset.imageAspectRatio || '3/4'; // default to 3/4 if not set

  if (productsGrid) {
    // MG: Added this here as the conflict between page load and Alpine toggling visibility was causing layout issues,especially with filters. A slight delay ensures everything is settled before the resize event is fired.
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 300);
    filterToggleButton === null || filterToggleButton === void 0 || filterToggleButton.addEventListener('click', function () {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 200);
      // MG: I've added this slight delay, above, to ensure the layout has updated after the filter interaction, before recalculating heights
    });
    var resizeObserver = new ResizeObserver(function () {
      var images = productsGrid.querySelectorAll('img:not(.product-item--featured-image img)');
      images.forEach(function (img) {
        var imgWidth = img.offsetWidth;
        if (aspectRatio.includes('/')) {
          var _aspectRatio$split$ma = aspectRatio.split('/').map(Number),
            _aspectRatio$split$ma2 = _slicedToArray(_aspectRatio$split$ma, 2),
            width = _aspectRatio$split$ma2[0],
            height = _aspectRatio$split$ma2[1];
          var newHeight = imgWidth / width * height;
          img.style.height = "".concat(newHeight, "px");
        }
      });
    });
    resizeObserver.observe(productsGrid);
  }
});
function sortBy() {
  Shopify.queryParams = {};
  if (location.search.length) {
    var params = location.search.substr(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');
      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }
  document.querySelector('#sort-by').addEventListener('change', function (e) {
    var value = e.target.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });
}
function collectionCTA() {
  var ctaContainers = document.querySelectorAll('.collection-inline-cta-container');
  ctaContainers.forEach(function (ctaContainer) {
    var number = parseInt(ctaContainer.getAttribute('data-cta-position'));
    var nthChild = document.querySelector('#collection-product-listing .product-card:nth-child(' + number + ')');
    if (typeof nthChild != 'undefined' && nthChild != null) {
      nthChild.insertAdjacentElement('afterend', ctaContainer);
    }
  });
}
function toggleFadeClass() {
  var collectionCollapsible = document.querySelectorAll('.collection-collapsible');
  collectionCollapsible.forEach(function (content) {
    var collectionDescription = content.querySelector('.collection-description');
    var readmoreBtn = content.querySelector('.collection-read-more');
    if (collectionDescription.scrollHeight > collectionDescription.clientHeight) {
      readmoreBtn.classList.remove('hidden');
    } else {
      readmoreBtn.classList.add('hidden');
    }
    if (typeof readmoreBtn != 'undefined' && readmoreBtn != null) {
      readmoreBtn.addEventListener('click', function () {
        if (collectionDescription.classList.contains('fade')) {
          collectionDescription.classList.remove('fade');
          readmoreBtn.textContent = 'Read Less';
        } else {
          collectionDescription.classList.add('fade');
          readmoreBtn.textContent = 'Read More';
        }
      });
    }
  });
}
function addFullHeightOnFilterClick() {
  var filterBtn = document.querySelector('#collection-filters button');
  if (filterBtn) {
    filterBtn.addEventListener('click', function () {
      var images = document.querySelectorAll('.product-card .flickity-slider img');
      images.forEach(function (img) {
        img.classList.add('h-full');
      });
    });
  }
}
function setupCustomFlickityNavigation() {
  var nextButtons = document.querySelectorAll('.flickity-button-js.next');
  var prevButtons = document.querySelectorAll('.flickity-button-js.prev');
  function updateButtonState(flickityInstance, prevBtn, nextBtn) {
    if (!flickityInstance) return;
    var selectedIndex = flickityInstance.selectedIndex;
    var lastIndex = flickityInstance.slides.length - 1;
    if (prevBtn) {
      if (selectedIndex === 0) {
        prevBtn.setAttribute('disabled', 'disabled');
      } else {
        prevBtn.removeAttribute('disabled');
      }
    }
    if (nextBtn) {
      if (selectedIndex === lastIndex) {
        nextBtn.setAttribute('disabled', 'disabled');
      } else {
        nextBtn.removeAttribute('disabled');
      }
    }
  }
  nextButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var carousel = btn.closest('.card-carousel-parent');
      if (!carousel) return;
      var flickityCarousel = carousel.querySelector('.card-carousel');
      if (!flickityCarousel) {
        console.error('No .card-carousel found in carousel parent.');
        return;
      }
      var flickityInstance = flickityCarousel.flickityInstance;
      if (!flickityInstance) {
        if (typeof Flickity !== 'undefined') {
          flickityInstance = new Flickity(flickityCarousel, {});
          flickityCarousel.flickityInstance = flickityInstance;
        } else {
          console.error('Flickity is not loaded.');
          return;
        }
      }
      flickityInstance.next();
    });
  });
  prevButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var carousel = btn.closest('.card-carousel-parent');
      if (!carousel) return;
      var flickityCarousel = carousel.querySelector('.card-carousel');
      if (!flickityCarousel) {
        console.error('No .card-carousel found in carousel parent.');
        return;
      }
      var flickityInstance = flickityCarousel.flickityInstance;
      if (!flickityInstance) {
        if (typeof Flickity !== 'undefined') {
          flickityInstance = new Flickity(flickityCarousel, {});
          flickityCarousel.flickityInstance = flickityInstance;
        } else {
          console.error('Flickity is not loaded.');
          return;
        }
      }
      flickityInstance.previous();
    });
  });
  var carousels = document.querySelectorAll('.card-carousel');
  carousels.forEach(function (flickityCarousel) {
    var carouselParent = flickityCarousel.closest('.card-carousel-parent');
    var prevBtn = carouselParent ? carouselParent.querySelector('.flickity-button-js.prev') : null;
    var nextBtn = carouselParent ? carouselParent.querySelector('.flickity-button-js.next') : null;
    var flickityInstance = flickityCarousel.flickityInstance;
    if (!flickityInstance && typeof Flickity !== 'undefined') {
      flickityInstance = new Flickity(flickityCarousel, {});
      flickityCarousel.flickityInstance = flickityInstance;
    }
    if (flickityInstance) {
      flickityInstance.on('select', function () {
        updateButtonState(flickityInstance, prevBtn, nextBtn);
      });
      updateButtonState(flickityInstance, prevBtn, nextBtn);
    }
  });
}
var loadMoreBtn = document.querySelector('.loadMore-button');
if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', function () {
    setTimeout(setupCustomFlickityNavigation, 500);
  });
}
setupCustomFlickityNavigation();
addFullHeightOnFilterClick();
sortBy();
collectionCTA();
toggleFadeClass();
/******/ })()
;